import React, { FC, memo } from "react";

const ViewDetailsIcon: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8C1 8 3.54545 3 8 3C12.4545 3 15 8 15 8C15 8 12.4545 13 8 13C3.54545 13 1 8 1 8Z"
      stroke="#495A64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.1429C9.1598 10.1429 10.1 9.18347 10.1 8C10.1 6.81653 9.1598 5.85714 8 5.85714C6.8402 5.85714 5.9 6.81653 5.9 8C5.9 9.18347 6.8402 10.1429 8 10.1429Z"
      stroke="#495A64"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default memo(ViewDetailsIcon);
